<!-- Dropdown menu item that navigates to an external URL, optionally in a new tab. -->

<script lang="ts" setup>
import { navigateToUrl } from '@nzyme/vue-utils/navigateToUrl.js';
import { DropdownMenuItem } from 'reka-ui';
import type { Component, VNodeChild } from 'vue';

import ExternalLink from '../ExternalLink.vue';
import commonCss from './Dropdown.module.scss';
import DropdownItemContent from './DropdownItemContent.vue';

interface Props {
  href: string;
  newTab?: boolean;
  icon?: Component | null;
}

interface Slots {
  default: () => VNodeChild;
  help: () => VNodeChild;
}

defineProps<Props>();
defineSlots<Slots>();
</script>

<template>
  <DropdownMenuItem
    :class="[commonCss.item]"
    @click="navigateToUrl(href)"
  >
    <ExternalLink
      :href="href"
      :class="css.link"
      :new-tab="newTab"
    >
      <DropdownItemContent :icon="icon">
        <slot />

        <template
          v-if="$slots.help"
          #help
        >
          <slot name="help" />
        </template>
      </DropdownItemContent>
    </ExternalLink>
  </DropdownMenuItem>
</template>

<style lang="scss" module="css">
.link {
  display: block;
  text-decoration: none;
}
</style>
